import React from "react";
import {
    ClipboardCheck,
    BarChart3,
    School,
    TrendingUp,
    type LucideIcon,
} from "lucide-react";
import { useInView } from "@/hooks/useInView";
import styles from "./FeatureCards.module.css";

interface feature {
    icon: LucideIcon;
    title: string;
    description: string;
}

const FEATURES: feature[] = [
    {
        icon: ClipboardCheck,
        title: "Simulacros realistas",
        description:
            "Pruebas tipo Saber 11 / ICFES con la estructura, las áreas y los tiempos reales.",
    },
    {
        icon: BarChart3,
        title: "Resultados y percentiles",
        description:
            "Puntajes, percentiles y comparativas claras apenas terminas el simulacro.",
    },
    {
        icon: School,
        title: "Reportes por colegio",
        description:
            "Cada institución visualiza el desempeño de sus propios estudiantes.",
    },
    {
        icon: TrendingUp,
        title: "Seguimiento del progreso",
        description:
            "Mide cómo evolucionas a lo largo de los simulacros y enfoca tu estudio.",
    },
];

const FeatureCards: React.FC = () => {
    const { ref, inView } = useInView<HTMLElement>();
    return (
        <section
            ref={ref}
            className={`${styles.section} ${inView ? styles.visible : ""}`}
        >
            <h2 className={styles.heading}>¿Qué te ofrece EduData?</h2>
            <div className={styles.grid}>
                {FEATURES.map((f, i) => {
                    const Icon = f.icon;
                    return (
                        <article
                            key={f.title}
                            className={styles.card}
                            style={{ "--i": i } as React.CSSProperties}
                        >
                            <div className={styles.iconWrap}>
                                <Icon size={24} />
                            </div>
                            <h3 className={styles.cardTitle}>{f.title}</h3>
                            <p className={styles.cardText}>{f.description}</p>
                        </article>
                    );
                })}
            </div>
        </section>
    );
};

export default FeatureCards;
